import { ContractContactData } from './contract-contact-data';
import { ScaffoldItemDimensionsData } from './scaffold-item-dimensions-data';
import { ScaffoldItemStatusEnum } from '../../enum/scaffold-item-status.enum';
import { ScaffoldingSystemTypeData } from './scaffolding-system-type-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class ScaffoldItemData {
  MaximumTonnage: number;
  StandingTonnage: number;
  ScaffoldItemId: string;
  ScaffoldTypeId: string;
  ScaffoldTypeFurtherInformation: string;
  QuoteNumber: string;
  QuoteItemNumber: string;
  QuoteItemName: string;
  Description: string;
  SiteInstructionReference: string;
  SiteInstructionRecivedFrom: ContractContactData;
  ContractPrice: number;
  ExtraHireRate: number;
  HirePeriod: number;
  DesignTypeId: string;
  DesignTypeFurtherInformation: string;
  LoadingLimitId: string;
  LoadingLimitFurtherInformation: string;
  MethodOfTyingId: string;
  MethodOfTyingFurtherInformation: string;
  MethodOfCladdingId: string;
  MethodOfCladdingFurtherInformation: string;
  ScaffoldItemDimensions: ScaffoldItemDimensionsData;
  ScaffoldItemStatus: ScaffoldItemStatusEnum;
  ScaffoldingSystemId: string;
  ScaffoldingSystemData: ScaffoldingSystemTypeData;
}


